import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sets the document <title> and <meta name="description"> for the current page.
 *
 * @param {string} titleKey   - i18n translation key for the page title
 * @param {string} descKey    - i18n translation key for the meta description
 * @param {Object} [options]
 * @param {string} [options.canonicalPath] - path appended to base URL for canonical link (e.g. '/contacts')
 */
const BASE_URL = 'https://dietistpro.com';

const useDocumentMeta = (titleKey, descKey, options = {}) => {
    const { t } = useTranslation();

    useEffect(() => {
        // Title
        const title = t(titleKey);
        document.title = title ? `${title} | DietistPro` : 'DietistPro';

        // Meta description
        const desc = t(descKey);
        let metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', desc);
        }

        // Canonical URL
        if (options.canonicalPath !== undefined) {
            let link = document.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', 'canonical');
                document.head.appendChild(link);
            }
            link.setAttribute('href', `${BASE_URL}${options.canonicalPath}`);
        }

        // OG tags
        const ogTitle = document.querySelector('meta[property="og:title"]');
        if (ogTitle) ogTitle.setAttribute('content', title ? `${title} | DietistPro` : 'DietistPro');

        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) ogDesc.setAttribute('content', desc);

        const ogUrl = document.querySelector('meta[property="og:url"]');
        if (ogUrl && options.canonicalPath !== undefined) {
            ogUrl.setAttribute('content', `${BASE_URL}${options.canonicalPath}`);
        }

        // Twitter tags
        const twTitle = document.querySelector('meta[name="twitter:title"]');
        if (twTitle) twTitle.setAttribute('content', title ? `${title} | DietistPro` : 'DietistPro');

        const twDesc = document.querySelector('meta[name="twitter:description"]');
        if (twDesc) twDesc.setAttribute('content', desc);
    }, [t, titleKey, descKey, options.canonicalPath]);
};

export default useDocumentMeta;
